import styled from "styled-components";

export const FlorenzButton = styled.div`
  justify-content: space-between;
  width: ${({ $widthComplete }) => ($widthComplete ? "100%" : "auto")};
  box-sizing: border-box;
  .button {
    width: 100%;
    display: flex;
    border-radius: 14px;
    align-items: center;
    justify-content: center;
    width: ${({ $text, $icon, $size }) =>
      $size === "s"
        ? ($text && !$icon) || ($text && $icon)
          ? "100%"
          : "36px"
        : ($text && !$icon) || ($text && $icon)
          ? "100%"
          : "61px"};
    height: ${({ $size }) => ($size === "s" ? "36px" : "61px")};
    padding: ${({ $text, $icon }) =>
      ($text && !$icon) || ($text && $icon) ? "0 20px" : "0"};
    border: ${({ $typeStyle, $disabled }) =>
      $disabled
        ? "none"
        : $typeStyle === "outline"
          ? `2px solid #FFFFFF`
          : $typeStyle === "primary"
            ? `1px solid #FFFFFF`
            : "none"};
    border: ${({ $typeStyle, $disabled }) =>
      $disabled
        ? "none"
        : $typeStyle === "outline"
          ? `2px solid #FFFFFF`
          : $typeStyle === "primary"
            ? `1px solid #FFFFFF`
            : "none"};
    /* width: ${({ $size, $typeStyle, $disabled }) =>
      $size === "s" && $disabled
        ? "36px"
        : $size === "m" && $disabled
          ? "61px"
          : $size === "s" && $typeStyle === "outline"
            ? "32px"
            : $size === "m" && $typeStyle === "outline"
              ? "57px"
              : "auto"}; */
    background-color: ${({ $typeStyle, $disabled }) =>
      $disabled
        ? "#CFD3DD"
        : $typeStyle === "primary"
          ? `#2A28D6`
          : $typeStyle === "secondary"
            ? `#F0F0FF`
            : $typeStyle === "secondaryWhite"
              ? `#FFFFFF`
              : $typeStyle === "success"
                ? `#00A600`
                : "#EFEFF9"};
    &__text {
      font-size: ${({ $size }) => ($size === "s" ? "18px" : "20px")};
      white-space: nowrap;
      /* font-family: ${({ $typeStyle }) =>
        $typeStyle === "outline" ? "Nunito Sans Bold" : "Nunito Sans"}; */
      color: ${({ $typeStyle, $disabled }) =>
        $disabled
          ? "#3E3E5B"
          : $typeStyle === "primary"
            ? `#FFFFFF`
            : $typeStyle === "secondary" || $typeStyle === "secondaryWhite"
              ? `#0C0AA2`
              : $typeStyle === "success"
                ? `#FFFFFF`
                : "#0C0AA2"};
    }
    &__icon {
      margin-left: ${({ $text }) => ($text ? "10px" : "0px")};
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: ${({ $iconSize }) => $iconSize || "20px"};
      color: ${({ $typeStyle, $disabled }) =>
        $disabled
          ? "#3E3E5B"
          : $typeStyle === "primary"
            ? `#FFFFFF`
            : $typeStyle === "secondary" || $typeStyle === "secondaryWhite"
              ? `#0C0AA2`
              : $typeStyle === "success"
                ? `#FFFFFF`
                : "#0C0AA2"};
    }
    &__disabled {
      margin-left: 5px;
      .icon {
        font-size: 14px;
      }
    }
  }
`;
